<template>
	<div class="p-navigation">
		<div class="p-navigation__menu">
			<SiteMenu :navigation="navigation"></SiteMenu>
		</div>
		<div class="p-navigation__text">
			<p>Business areas - Port esbjerg</p>
		</div>
	</div>
</template>

<script>
import { defineComponent } from "vue";
import SiteMenu from "@/js/components/SiteMenu.vue"

export default defineComponent({
    name: "pNavigation",
    components: {
		SiteMenu
    },
	props: {
		navigation: Array,
	},

    data() {
        return{

        }
    },

    methods: {

    },
    mounted(){
    }
});
</script>

<style lang="scss">
@import "@/scss/app.scss";

.p-navigation{
	// position: fixed;
	top: 0;
	right: 0;
	width: 80px;
	min-width: 80px;
	height: 100vh;
	background-color: $brand-white;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	align-items: center;

	padding-bottom: 78px;
	border-left: 1px solid #EBEDEF;

	&__menu{
		height: 78px;
	}
	&__text{
		display: flex;
		flex-grow: 1;
		p{
			writing-mode: vertical-lr;
			text-orientation: mixed;
			transform: rotate(180deg);
			text-transform: uppercase;

			font-size: 11px;
			letter-spacing: 2.5px;
			text-align: center;
			color: #817A74;
		}
	}
}

@media all and (max-width: 500px) {
 .p-navigation{
	 display: none;
 }
}
</style>
